import { Component, Input } from '@angular/core';

@Component({
  selector: 'atom-loading-inline',
  standalone: true,
  imports: [],
  templateUrl: './loading-inline.component.html',
  styleUrl: './loading-inline.component.css'
})
export class LoadingInlineComponent {
  @Input('message') message: string | undefined;
  @Input('title') title: string | undefined;

  @Input('loaderSize') loaderSize: number = 16;
  @Input('hideMessage') hideMessage: boolean = false;
}
